import { inject, ref, type Ref } from "vue";
import type { IDatenjahrService } from "../services/datenjahr";
import type { Anmerkung } from "../services/datenjahr/model";

export const FeedbackSymbol = Symbol();


export class FeedbackHandler {
  private _service: IDatenjahrService;
  private _items: Ref<Anmerkung[]>;
  private _detailId: Ref<string | undefined>;
  private _title: Ref<string | undefined>;

  public FeedbackModus: Ref<boolean>;
  public FeedbackDataId: Ref<string | undefined>;

  public BezugsObjektId: Ref<string | undefined>;

  constructor(service: IDatenjahrService) {
    this._service = service;
    this._items = ref<Anmerkung[]>([]);
    this._detailId = ref(undefined);
    this._title = ref(undefined);
    this.FeedbackModus = ref(false);
    this.FeedbackDataId = ref();
    this.BezugsObjektId = ref();
  }

  async Load(): Promise<void> {
    if(this._service.DatenjahrIsSet.value)
      this._items.value = await this._service.Anmerkungen.List() as Anmerkung[];
  }

  get Items(): Ref<Anmerkung[]> {
    return this._items;
  }

  get DetailId(): Ref<string | undefined> {
    return this._detailId;
  }

  set DetailId(detailId: string) {
    this._detailId.value = detailId;
  }

  set Title(title: string) {
    this._title.value = title;
  }

  async SaveFeedback(anmerkung: Anmerkung): Promise<void> {
    anmerkung.detailId = this._detailId.value;
    anmerkung.titel = (this._title.value ?? anmerkung.titel) + ' (' + anmerkung.titel + ')';

    await this._service.Anmerkungen.Patch(anmerkung);
    await this.Load();   
  }

  async Erledige(anmerkung: Anmerkung): Promise<void> {
    anmerkung.istErledigt = anmerkung.istErledigt;
    await this._service.Anmerkungen.Patch(anmerkung);
  }

  async DeleteFeedback(anmerkung?: Anmerkung): Promise<void> {
    if (!anmerkung || !anmerkung.id)
      return;

    this._items.value = this._items.value.filter(item => item.id !== anmerkung.id);
    await this._service.Anmerkungen.Delete(anmerkung.id);
  }
}


export const useFeedback = () => {
  const Feedback = inject(FeedbackSymbol) as FeedbackHandler

  return {
    Feedback
  }
}